export const SummaryData = [
  {
    imgName: 'airWayBill.png',
    label: 'Airwaybill',
  },
  {
    imgName: 'clearedItem.png',
    label: 'Cleared',
  },
  {
    imgName: 'withheldItem.png',
    label: 'Withheld',
  },

  {
    imgName: 'highValueItem.png',
    label: 'High Value',
  },
];
